var map = {
	"./icon_beer.png": "d3a3",
	"./icon_bell.png": "6d60",
	"./icon_chat.png": "33d7",
	"./icon_fire.png": "f5166",
	"./icon_friend.png": "0686",
	"./icon_ghost.png": "445b",
	"./icon_glasses.png": "dd80",
	"./icon_handshake.png": "cbb9",
	"./icon_palette.png": "c8f1",
	"./icon_police.png": "9959"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f2e";